import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserDataServicesService } from "../services/user-data-services.service";
import { IUser, PagedUserResponse } from "src/app/shared/interfaces/iuser";
import { RoleService } from "../../roles/services/role.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.css"],
})
export class UserListComponent implements OnInit {

  Users: IUser[] = [];
  Roles: any[] = [];
  selectedRole: string = "";
  projectId!: string;
  isLoading = true;

  page = 0;
  size = 15;
  totalPages = 0;

  constructor(
    private userService: UserDataServicesService,
    private roleService: RoleService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.projectId = this.route.snapshot.paramMap.get("projectId")!;

    // 🔥 ENFORCE THAT A USER LIST MUST ALWAYS BELONG TO A PROJECT
    if (!this.projectId) {
      throw new Error("User list must always be tied to a project. projectId is missing.");
    }

    this.loadRoles();
    this.getUsersForProject();
  }

  // -----------------------------------------------------
  // Load USERS for this specific project only
  // -----------------------------------------------------
  getUsersForProject() {
    this.isLoading = true;

    const request$ = this.selectedRole
      ? this.userService.getUsersForProjectByRole(
        this.projectId,
        this.selectedRole,
        this.page,
        this.size
      )
      : this.userService.getUsersForProject(
        this.projectId,
        this.page,
        this.size
      );

    request$.subscribe({
      next: (res) => {
        this.Users = res.content || [];
        this.totalPages = res.totalPages;
        this.isLoading = false;
      },
      error: () => {
        this.Users = [];
        this.isLoading = false;
      }
    });
  }


  // -----------------------------------------------------
  // Load ROLES for this specific project only
  // -----------------------------------------------------
  loadRoles() {
    this.roleService.getRolesForProject(this.projectId).subscribe({
      next: (res) => this.Roles = res.content || res,
      error: (err) => console.error("Failed to load project roles", err),
    });
  }

  // -----------------------------------------------------
  // Pagination handlers
  // -----------------------------------------------------
  nextPage() {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.getUsersForProject();
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.getUsersForProject();
    }
  }

  changeSize() {
    this.page = 0;
    this.getUsersForProject();
  }

  resetFilter() {
    this.selectedRole = "";
    this.page = 0;
    this.getUsersForProject();
  }

  // -----------------------------------------------------
  // Navigation — ALWAYS include projectId
  // -----------------------------------------------------
  viewUser(id: string) {
    this.router.navigate([`/project-users/${this.projectId}/user-details/${id}`]);
  }

  editUser(id: string) {
    this.router.navigate([`/project-users/${this.projectId}/user-edit/${id}`]);
  }

  // -----------------------------------------------------
  // Role filter (Project-specific)
  // -----------------------------------------------------
  autoFilter() {
    if (!this.selectedRole) {
      this.page = 0;
      this.getUsersForProject();
      return;
    } console.log("Selected Role:", this.selectedRole);
    console.log("User Role ID:", this.Users[0]?.role?.id);


    // If you want project-role filtering, use:
    this.userService.getUsersForProject(this.projectId, 0, 9999).subscribe({
      next: (res) => {
        this.Users = res.content.filter(u => u.role.id === this.selectedRole);
        this.totalPages = 1;
        this.page = 0;
      },
      error: () => {
        this.Users = [];
        this.totalPages = 0;
      }
    });
  }

  formatDate(date?: string): string {
    return date ? date.split("T")[0] : "";
  }

  onRoleFilterChange(event: Event) {
    this.selectedRole = (event.target as HTMLSelectElement).value || "";
    this.page = 0;
    this.getUsersForProject();
  }



}
